import React from 'react';
import { FileText } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const Docs: React.FC = () => {
  const { t } = useTranslation();
  
  return (
    <div className="min-h-screen bg-white dark:bg-[#111111] pt-16 transition-colors duration-300">
      <div className="flex items-center justify-center min-h-[calc(100vh-4rem)] px-4">
        <div className="text-center">
          <FileText className="w-16 h-16 sm:w-20 sm:h-20 lg:w-24 lg:h-24 mx-auto mb-4 sm:mb-6 text-gray-300 dark:text-gray-600" />
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 dark:text-gray-100 mb-3 sm:mb-4">
            {t('docs.comingSoon')}
          </h1>
          <p className="text-base sm:text-lg lg:text-xl text-gray-600 dark:text-gray-400">
            {t('docs.underConstruction')}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Docs;
